import React from 'react';

export const withProviders = (Component: React.ComponentType, providers: React.ReactNode[]) => {
  const WrapperComponent = (props: any) => {
    const renderComponents = (renderMap: any[]) => {
      const Components = renderMap
        .reverse()
        .reduce((ComponentSoFar: React.ComponentType, Provider: React.ComponentType) => {
          const WrappedComponent = () => (
            <Provider>
              <ComponentSoFar {...props} />
            </Provider>
          );

          return WrappedComponent;
        }, Component); // initial value, first component

      return <Components />;
    };

    return renderComponents(providers);
  };

  return WrapperComponent;
};

